import * as angular from 'angular';

export interface HasTruthyPropertyFilter {
    /**
     * @ngdoc filter
     * @name pkpHasTruthyProperty
     * @memberof app
     *
     * @description
     * Removes entries where the given property evaluates to `false`.
     * This works for first level properties only---it can't iterate the structure recursively or any deeper.
     *
     * @param {Object[]} input
     * @param {String} propertyName Name of the property to evaluate.
     *
     * @author somarten.btc
     */
    (input: any[], propertyName: string): any[];
}

function hasTruthyPropertyFilter(): HasTruthyPropertyFilter | null {
    return function (input: any[], propertyName: string): any[] {
        if (!input) {
            return input;
        }
        var result: any[] = [];

        for (var i = 0; i < input.length; i++) {
            if (!!input[i][propertyName]) {
                result.push(input[i]);
            }
        }

        return result;
    };
}

angular.module('app').filter('pkpHasTruthyProperty', hasTruthyPropertyFilter);
